<app-nav></app-nav>
<section class="medical-panel">
  <div class="container">
    <div class="col">
        <div class="panel panel-default">
          <div class="panel-heading">&nbsp;</div>
          <div class="panel-body">
              <div class="row">
                  <div class="col-4">Card No: </div>
                  <div class="col-8">A232134</div>
              </div>
              <div class="row">
                  <div class="col-4">Name: </div>
                  <div class="col-8">Manish</div>
              </div>
              <div class="row">
                  <div class="col-4">Age: </div>
                  <div class="col-8">32</div>
              </div>
              <div class="row">
                  <div class="col-4">Gender: </div>
                  <div class="col-8">Male</div>
              </div>
              <div class="row">
                  <div class="col-4">Relation: </div>
                  <div class="col-8">self</div>
              </div>
              <div class="row">
                  <div class="col-4">Sum Insured: </div>
                  <div class="col-8">400000</div>
              </div>
              <div class="row">
                  <div class="col-4">Mobile: </div>
                  <div class="col-8">1234567890</div>
              </div>
              <div class="row">
                  <div class="col-4">Email: </div>
                  <div class="col-8">manish@test.com</div>
              </div>
              <div class="row">
                  <div class="col-4">DOB: </div>
                  <div class="col-8">Jan 25 2019</div>
              </div>
              <div class="row">
                  <div class="col-4">ACTION: </div>
                  <div class="col-8"></div>
              </div>
          </div>
        </div>
    </div>
    <div class="col">
        <div class="panel panel-default">
          <div class="panel-heading">&nbsp;</div>
          <div class="panel-body">
              <div class="row">
                  <div class="col-4">Card No: </div>
                  <div class="col-8">A232134</div>
              </div>
              <div class="row">
                  <div class="col-4">Name: </div>
                  <div class="col-8">Manish</div>
              </div>
              <div class="row">
                  <div class="col-4">Age: </div>
                  <div class="col-8">32</div>
              </div>
              <div class="row">
                  <div class="col-4">Gender: </div>
                  <div class="col-8">Male</div>
              </div>
              <div class="row">
                  <div class="col-4">Relation: </div>
                  <div class="col-8">self</div>
              </div>
              <div class="row">
                  <div class="col-4">Sum Insured: </div>
                  <div class="col-8">400000</div>
              </div>
              <div class="row">
                  <div class="col-4">Mobile: </div>
                  <div class="col-8">1234567890</div>
              </div>
              <div class="row">
                  <div class="col-4">Email: </div>
                  <div class="col-8">manish@test.com</div>
              </div>
              <div class="row">
                  <div class="col-4">DOB: </div>
                  <div class="col-8">Jan 25 2019</div>
              </div>
              <div class="row">
                  <div class="col-4">ACTION: </div>
                  <div class="col-8"></div>
              </div>
          </div>
        </div>
    </div>
  </div>
</section>
